module.exports = __webpack_public_path__ + "img/left.100db7b1.png";